import { css } from "lit";

export const styles = css`
  .posts-mobile-header {
    position: relative;
    box-sizing: border-box;
    width: 100vw;
    min-height: 280px;
    background-color: var(--sds-color-background-default-tertiary);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    overflow: hidden;
  }

  /* Hide on desktop - only show on mobile */
  @media (min-width: 769px) {
    .posts-mobile-header {
      display: none;
    }
  }

  .posts-mobile-header.has-background {
    background-color: transparent;
  }

  .gradient-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgb(17 17 17 / 0) 0%, #111 100%);
    z-index: 1;
    pointer-events: none;
  }

  .background-video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
    pointer-events: none;
  }

  .posts-mobile-header.is-video {
    background-color: transparent;
  }

  .user-profile-overlay {
    position: absolute;
    left: var(--sds-size-space-800);
    right: var(--sds-size-space-800);
    bottom: 80px;
    display: grid;
    grid-template:
      "avatar name" auto
      "social social" auto
      / 64px 1fr;
    gap: var(--sds-size-space-600) var(--sds-size-space-600);
    row-gap: var(--sds-size-space-300);
    z-index: 2;
  }

  .user-name {
    grid-area: name;
    font-family: var(--sds-typography-family-title);
    font-size: var(--sds-typography-heading-size);
    font-weight: var(--sds-typography-weight-medium);
    line-height: 1.5em;
    color: var(--sds-color-text-default-default);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    align-self: center;
  }

  .social-links {
    grid-area: social;
    display: flex;
    gap: var(--sds-size-space-300);
    align-items: center;
  }

  .social-link-button {
    width: 32px;
    height: 32px;
    border-radius: var(--sds-size-radius-full);
    background-color: var(--theme-secondary-color, var(--sds-color-background-neutral-secondary));
    border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: default;
    transition: background-color 0.2s ease;
  }

  .social-link-icon {
    color: var(--theme-primary-color, var(--sds-color-icon-neutral-on-neutral-secondary));
    font-size: var(--sds-typography-body-size-small);
    font-weight: var(--sds-typography-weight-medium);
    width: 16px;
    height: 16px;
    transition: color 0.2s ease;
  }

  .social-link-button .social-link-icon {
    color: var(--theme-primary-color, var(--sds-color-white-500));
  }

  .tab-navigation {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 3;
    pointer-events: auto;
  }

  .tab-container {
    display: flex;
    justify-content: space-between;
    padding: 16px 23px 0;
  }

  .tab {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    color: var(--sds-color-text-default-tertiary);
    text-align: center;
    font-family: var(--sds-typography-family-title);
    font-size: var(--sds-typography-body-size-medium);
    font-weight: var(--sds-typography-weight-medium);
    line-height: 1;
    transition: color 0.2s ease;
  }

  .tab.active {
    color: #fff;
  }

  .tab:hover {
    color: var(--sds-color-text-default-secondary);
  }

  .tab.active:hover {
    color: #fff;
  }

  .tab-indicator {
    height: 2px;
    background-color: #8a226f;
    transition: all 0.3s ease;
    margin-top: 1rem;
    transform-origin: left;
  }
`;
